module.exports = __webpack_public_path__ + "img/bug.566ce805.svg";